"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BAD_DEBT_GL_ACCOUNT_IDS = exports.ALLOWANCE_FOR_BAD_DEBT_GL_ACCOUNT_IDS = exports.BAD_DEBT_TYPES = exports.TENANT_CONVENIENCE_FEE_GL_ACCOUNT_ID = void 0;
exports.TENANT_CONVENIENCE_FEE_GL_ACCOUNT_ID = 15;
exports.BAD_DEBT_TYPES = {
    RENT_INCOME: 'rent_income',
    OTHER_INCOME: 'other_income',
    TURN_DISPO: 'turn_dispo',
    OTHER_EXPENSES: 'other_expenses'
};
exports.ALLOWANCE_FOR_BAD_DEBT_GL_ACCOUNT_IDS = {
    [exports.BAD_DEBT_TYPES.RENT_INCOME]: 320000,
    [exports.BAD_DEBT_TYPES.OTHER_INCOME]: 323744,
    [exports.BAD_DEBT_TYPES.TURN_DISPO]: 320001,
    [exports.BAD_DEBT_TYPES.OTHER_EXPENSES]: 320643
};
exports.BAD_DEBT_GL_ACCOUNT_IDS = {
    [exports.BAD_DEBT_TYPES.RENT_INCOME]: 318128,
    [exports.BAD_DEBT_TYPES.OTHER_INCOME]: 323745,
    [exports.BAD_DEBT_TYPES.TURN_DISPO]: 318129,
    [exports.BAD_DEBT_TYPES.OTHER_EXPENSES]: 320644
};
